import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowPromoCode from "../../../components/SuperAdmin/PromoCode/ShowPromoCode";

export default withRouter(connect()(ShowPromoCode));
